import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import moment from 'moment';
import { Route } from 'vue-router';
import { tryParseInt } from './number';

/**
 * Pobiera plan
 *
 * @export
 * @param {Route} route
 * @param {() => void} next
 */
export function getPlan(route: Route, next: () => void) {
  const procedureId = tryParseInt(route.params.procedureId);
  store
    .dispatch('procedure/plan', { ...getPlanDateRange(route), procedureId })
    .then(plan => next())
    .catch(err => store.dispatch('notifyError', { title: Errors.PLAN_CANNOT_GET }));
}

/**
 * Zwraca zakres dat dla planu
 *
 * @param {Route} route
 * @returns {{ startDate: Date; endDate: Date }}
 */
function getPlanDateRange(route: Route): { startDate: Date; endDate: Date } {
  const year = tryParseInt(route.query.year);
  const september = 8;
  const july = 6;

  let momentDate = moment();

  if (year) {
    momentDate = momentDate.year(year);
  } else if (momentDate.month() < september) {
    momentDate = momentDate.subtract(1, 'year');
  }

  const startDate = momentDate
    .month(september)
    .startOf('month')
    .toDate();

  const endDate = momentDate
    .add(1, 'year')
    .month(july)
    .startOf('month')
    .toDate();

  return { startDate, endDate };
}
